<template>
    <v-dialog v-model="$store.state.oocompanies.add" max-width="600px">
        <v-card>
            <v-toolbar dense color="secondary">
                <v-toolbar-title class="white--text"
                    >Add Company</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.oocompanies.add = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container fluid>
                <v-form ref="form" lazy-validation>
                    <v-text-field
                        label="Company Name"
                        v-model="company"
                        dense
                        :rules="[v => !!v || 'Required']"
                        required
                    ></v-text-field
                    ><br />
                    <v-text-field
                        label="Email"
                        v-model="mail"
                        dense
                        :rules="emailRules"
                        required
                    ></v-text-field>
                </v-form>
                <v-row justify="end">
                    <v-btn class="mx-4 my-2" color="primary" @click="validate"
                        >Save</v-btn
                    >
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
export default {
    name: 'CredentialForm',
    props: ['id'],
    data: function() {
        return {
            mail: null,
            company: null,
            crendential: [
                { id: '1', CredentialType: 'Driver License' },
                { id: '2', CredentialType: 'Driver License' }
            ],
            emailRules: [
                value => {
                    if (value) return true;

                    return 'E-mail is requred.';
                },
                value => {
                    if (/.+@.+\..+/.test(value)) return true;

                    return 'E-mail must be valid.';
                }
            ]
        };
    },
    methods: {
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.newOOCompany();
            }
        },
        newOOCompany: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var params = {
                Company: this.company,
                Mail: this.mail
            };
            axios
                .post('oo-company', params)
                .then(response => {
                    console.log(response.data);
                    this.$emit('close');
                    str.state.isLoading = false;
                    this.$store.state.oocompanies.add = true;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });

                        str.state.isLoading = false;
                    }
                });
        }
    }
};
</script>

<style></style>
